export const NPSUBSCRIPTIONS_RESET_STATE = 'NPSUBSCRIPTIONS_RESET_STATE';
export const NPSUBSCRIPTIONS_CURRENT_ITEM = 'NPSUBSCRIPTIONS_CURRENT_ITEM';

export const NPSUBSCRIPTIONS_REQUEST_LOADING = 'NPSUBSCRIPTIONS_REQUEST_LOADING';
export const NPSUBSCRIPTIONS_REQUEST_SUCCESS = 'NPSUBSCRIPTIONS_REQUEST_SUCCESS';
export const NPSUBSCRIPTIONS_REQUEST_FAILED = 'NPSUBSCRIPTIONS_REQUEST_FAILED';

export const NPSUBSCRIPTIONS_CURRENT_ACTION = 'NPSUBSCRIPTIONS_CURRENT_ACTION';
export const NPSUBSCRIPTIONS_RESET_ACTION = 'NPSUBSCRIPTIONS_RESET_ACTION';
